__turbopack_context__.v({
  "tooltipArrowFill": "Tooltip-module__W3j9RW__tooltipArrowFill",
  "tooltipButtonVariant": "Tooltip-module__W3j9RW__tooltipButtonVariant",
  "tooltipButtonVariantDanger": "Tooltip-module__W3j9RW__tooltipButtonVariantDanger",
  "tooltipButtonVariantDisabled": "Tooltip-module__W3j9RW__tooltipButtonVariantDisabled",
  "tooltipButtonVariantDisabledDanger": "Tooltip-module__W3j9RW__tooltipButtonVariantDisabledDanger",
  "tooltipContent": "Tooltip-module__W3j9RW__tooltipContent",
  "tooltipGlossary": "Tooltip-module__W3j9RW__tooltipGlossary",
});
